import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    projectOrFolderType: string;
    fileType: string;
    itemCount: string;
    size: string;
    commentCountLabel: ({ count }: {
        count: number;
    }) => string;
    insertedDateTime: (insertedTime: Date) => string;
    insertedDateTimeA11y: (insertedTime: Date) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for project/folder type */
            projectOrFolderType: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch_AssetDetailPane.projectOrFolderType?c=k5idcnlneisq", defaultMessage: "Type" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for file type */
            fileType: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch_AssetDetailPane.fileType?c=2tbjkyczb2nje", defaultMessage: "Filetype" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for item count */
            itemCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch_AssetDetailPane.itemCount?c=3rvvcosu16xp7", defaultMessage: "Items" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for size */
            size: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch_AssetDetailPane.size?c=38m0cmesgfwnh", defaultMessage: "Size" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the comment count indicator (e.g. "5 comments"). */
            commentCountLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ count }: {
                        count: number;
                    }): string => __intl__.intl().formatMessage({ id: "QuickSearch_AssetDetailPane.commentCountLabel?c=9w6ib6tjh6dc", defaultMessage: "{count, plural, one {1 comment} other {{count} comments}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /**
             * Inserted date/time in readable format
             * Example (en-US): "Jan 15, 2026 at 2:30 PM"
             */
            insertedDateTime: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (insertedTime: Date): string => __intl__.intl().formatMessage({ id: "QuickSearch_AssetDetailPane.insertedDateTime?c=mzu6tnn6zbfq", defaultMessage: "{insertedTime, date, medium} at {insertedTime, time, short}" }, { insertedTime: insertedTime }));
                },
                enumerable: true,
                configurable: true
            },
            /**
             * Inserted date/time in full a11y format
             * Example (en-US): "January 15, 2026 at 2:30 PM"
             */
            insertedDateTimeA11y: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (insertedTime: Date): string => __intl__.intl().formatMessage({ id: "QuickSearch_AssetDetailPane.insertedDateTimeA11y?c=25tjhoej6hwqc", defaultMessage: "{insertedTime, date, long} at {insertedTime, time, short}" }, { insertedTime: insertedTime }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
